import React, { useEffect } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSlider } from './components/HeroSlider';
import { Services } from './components/Services';
import { Staff } from './components/Staff';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { updatePageSEO, generateStructuredData } from '../../utils/seo';

const HomePage: React.FC = () => {
  useEffect(() => {
    const siteUrl = window.location.origin;
    updatePageSEO({
      title: '岡山市・倉敷市の司法書士｜おかやま司法書士事務所',
      description: '岡山市・倉敷市を中心とした岡山県内で司法書士業務を提供。不動産登記、商業登記、相続手続き、債務整理、成年後見など幅広くサポート。おかやま司法書士事務所は2000年設立、経験豊富なスタッフが丁寧に対応いたします。初回相談30分無料。',
      keywords: '司法書士,岡山市,倉敷市,不動産登記,商業登記,相続手続き,債務整理,成年後見',
      canonical: `${siteUrl}/`,
      ogTitle: '岡山市・倉敷市の司法書士｜おかやま司法書士事務所',
      ogDescription: '岡山市・倉敷市を中心とした岡山県内で司法書士業務を提供。不動産登記、商業登記、相続手続き、債務整理、成年後見など幅広くサポート。',
      ogUrl: `${siteUrl}/`,
      structuredData: generateStructuredData.homepage()
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSlider />
        <Services />
        <Staff />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
